export const FETCH_RECIPIENTS_BEGIN   = "FETCH_RECIPIENTS_BEGIN"
export const FETCH_RECIPIENTS_SUCCESS = "FETCH_RECIPIENTS_SUCCESS"
export const FETCH_RECIPIENTS_FAILED  = "FETCH_RECIPIENTS_FAILED"

const fetchRecipientsBeginAction   =  (payload) => ({ type: FETCH_RECIPIENTS_BEGIN, payload })
const fetchRecipientsSuccessAction =  (payload) => ({ type: FETCH_RECIPIENTS_SUCCESS, payload })
const fetchRecipientsBeginFailed   =  (payload) => ({ type: FETCH_RECIPIENTS_FAILED, payload })

export const fetchRecipients = () => {
  return (dispatch) => {
    dispatch(fetchRecipientsBeginAction())
    return $.ajax({
      url: `/api/staff/v1/users/chat_recipients.json`,
      success:  response => dispatch(fetchRecipientsSuccessAction(response)),
      error: () => dispatch(fetchRecipientsBeginFailed()),
    })
  }
}